import { getDataMapper, mapField, getObjectId } from "@/shared";

export const mapEmployeeFiltersToServer = getDataMapper({
    point_id: mapField("points", getObjectId),
    position_id: mapField("positions", getObjectId),
});
